module.exports = __webpack_public_path__ + "a8b13525ee3b82f901196668f4733097.svg";